import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Menu } from 'src/app/@shared/models/menu.model';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';

@Component({
  selector: 'app-menu-panel',
  templateUrl: './menu-panel.component.html',
  styleUrls: ['./menu-panel.component.scss']
})
export class MenuPanelComponent implements OnInit {
  @ViewChild('menu', { static: true }) menu: MatMenu;
  @Input() items: Menu[];
  public isMobile: boolean;

  constructor() { }

  ngOnInit() {
    this.isMobile = detectar_mobile();
    if (!this.isMobile) {
      this.items = this.items.filter(p => {
        return !p.nome.endsWith('.mobile');
      })
    }
  }
}
